import { Helmet } from "react-helmet";
import {
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import cssVariables from "../../../../theme/cssVariables";
import Search from "@mui/icons-material/Search";
import * as Util from "../../../../services/global.service";

import GoalWorkflow from "./GoalWorkflow"
import EvaluationWorkflow from "./EvaluationWorkflow"
import EvaluationProbationWorkflow from "./EvaluationProbationWorkflow"

const useStyles = makeStyles({
  plusSvg: {
    "& > path": {
      fill: cssVariables.color.primary,
      stroke: "#fff",
    },
  },
  draggingListItem: {
    background: "rgb(235,235,235)",
  },
  flexPaper: {
    flex: 1,
    minWidth: 350,
    "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
    "border-radius": "10px !important        ",
  },
  tab: {
    fontSize: "16px !important",
    fontWeight: "300 !important",
    // color: "#A3A3A3 !important",
    "&.Mui-selected": {
      color: cssVariables.color.primary + " !important",
    },
  },
  root: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
  },
  tableHeader: {
    fontWeight: 500,
    fontSize: "14px!important",
    color: "#A0A0A0",
  },
  profileContainer: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    marginTop: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
})
const styles = {
  link: {
    color: "#5DA196",
    cursor: "pointer",
  },
  end: {
    color: "#A3A3A3",
  },
};

// main component
const CreateWorkflow = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state } = useLocation()
  const { id } = useParams()

  const goTo = (route, data) => {
    if (data) {
      navigate("/admin" + route, { replace: false, state: data });
    } else {
      navigate("/admin" + route, { replace: false });
    }
  }

  return (
    <Box sx={{ maxHeight: "100%", overflowY: "auto" }}>
      <Helmet>
        <title>Admin - Create Workflow | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => goTo("/workflow")}>
                {` ${t("adminWorkflow.label.title")}`}
              </span>{" "}
              /
              <span style={styles.end}>
                {` ${t("adminWorkflow.label.createWorkflow")}`}
              </span>
            </Typography>
          </Grid>
          <Grid container>
            <Grid item>
              <Typography color="#404349" fontSize={36} fontWeight="600">
                {t("adminWorkflow.label.createWorkflow")}
              </Typography>
            </Grid>
          </Grid>
          {/* ---------------------- Workflow Type Display ---------------------- */}
          {
            state?.type === "goal" ? <GoalWorkflow />
              : state?.type === "evaluation" ? <EvaluationWorkflow />
                : state?.type === "probation" ? <EvaluationProbationWorkflow />
                  : <></>}
        </Container>
      </Box>
    </Box>
  )
}

export default CreateWorkflow;
